import { memo, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { To } from 'react-router-dom';

import { Typography } from '@material-ui/core';
import clsx from 'clsx';

import { ArrowBackIcon, ArrowBackLong, Button, colors } from '@chhjit/react-components';

import { useStyles } from './styles';
import { BackButtonProps } from './types';

export const BackButton = memo(
  ({
    id,
    url,
    name,
    color = colors.primary.main,
    isNavigation,
    iconLong = false,
    iconSize = 13,
    size = 'medium',
    classes,
    onClick,
    hideText = false,
  }: BackButtonProps) => {
    const styles = useStyles({ isNavigation });

    const navigate = useNavigate();

    const handleOnClick = useCallback(() => {
      if (onClick) {
        onClick();
        return;
      }

      navigate(url || (-1 as To));
    }, [url, onClick, navigate]);

    return (
      <Button
        id={id}
        buttonType="text"
        size={size}
        style={{ color }}
        classes={{ root: styles.buttonRoot }}
        onClick={handleOnClick}
        aria-label="Go back"
      >
        <div className={clsx(styles.contentRoot)}>
          {iconLong ? (
            <ArrowBackLong fontSize={24} color="inherit" className={classes?.icon} />
          ) : (
            <ArrowBackIcon fontSize={iconSize} color="inherit" className={classes?.icon} />
          )}

          {!hideText && (
            <Typography
              variant={size === 'small' ? 'h5' : 'h4'}
              color="inherit"
              className={clsx(styles.title, classes?.title)}
            >
              {name ? name : 'Back'}
            </Typography>
          )}
        </div>
      </Button>
    );
  },
);
